module.exports = __webpack_public_path__ + "assets/rapido-wordmark.62bafbdbb45ae8030962ac7c7107cb61.png";